<!--Login header  -->
<div *ngIf="loadLoginPage">
  <div class="header-gradient"></div>
  <div class="header">
    <div class="divider main-tab">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-lg-2 logo-section">
            <img class="logo" src="../../../../assets/images/Logo.png" alt="Alight Care Portal" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-alerts *ngIf="rootScope.ssoError" [isWarningToHide]="rootScope.isWarningToHide" [isErrorToHide]="false"
    [isInfoToHide]="rootScope.isInfoToHide" [isSuccessToHide]="rootScope.isSuccessToHide" [msg]="rootScope.ssoError">
  </app-alerts>
  <div class="main-login">
    <div class="login-container">
      <div class="row">
        <div class="col-md-12">
          <div class="login-logo"></div>

          <h1 class="heading">Enter your LAN ID & Password to log in.</h1>
          <app-alerts *ngIf="!rootScope.isWarningToHide" [isWarningToHide]="rootScope.isWarningToHide"
            [isErrorToHide]="rootScope.isErrorToHide" [isInfoToHide]="rootScope.isInfoToHide"
            [isSuccessToHide]="rootScope.isSuccessToHide" [msg]="rootScope.alertMsg">
          </app-alerts>

          <section *ngIf="rootScope.loginAccountUnexpectedError" class="error-wrapper">
            <f-alert variant="error">
              <p class="full-width">
                An unexpected error has occured, please try to login again. If
                issue persists contact myIT.
              </p>
            </f-alert>
          </section>

          <section *ngIf="rootScope.loginAccountUnauthorizedError" class="error-wrapper">
            <f-alert class="error-without-heading" variant="error">
              <p class="full-width">
                The LAN ID and/or Password entered is incorrect, please try
                again.
              </p>
              <p class="full-width">
                For your security, you’re allowed a certain number of attempts
                before your account is locked.
              </p>
            </f-alert>
          </section>

          <section *ngIf="rootScope.loginAccountBlockedError" class="error-wrapper">
            <f-alert class="error-with-heading" variant="error">
              <h4>Your account is locked.</h4>
              <p class="full-width">
                Accounts are locked after too many failed login attempts. Go to
                <a title="https://alight.saviyntcloud.com/" href="https://alight.saviyntcloud.com/" target="_blank">
                  myIdentity</a>
                to reset your password.
              </p>
            </f-alert>
          </section>

          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div>
              <mat-form-field appearance="fill" class="component-box">
                <mat-label>LAN ID (required)</mat-label>

                <input  autocomplete="off" matInput formControlName="lanId" id='txtLanId' />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="fill" class="component-box pwd-box">
                <mat-label>Password (required)</mat-label>

                <input autocomplete="off" [type]="inputDataType" matInput formControlName="password" id='txtLoginPwd'
                   />
                <f-button *ngIf="hidePwdIcon && accountNotBlocked" [iconConfig]="iconConfigEye"
                  (click)="togglePwdIcon()" type="button" variant="ghost" class="eye-btn">
                </f-button>
                <f-button *ngIf="!hidePwdIcon && accountNotBlocked" [iconConfig]="iconConfigEyeSlash"
                  (click)="togglePwdIcon()" type="button" variant="ghost" class="eye-btn">
                </f-button>
              </mat-form-field>
            </div>
            <div class="login-form-control">
              <f-button text="Login" [disabled]="loginForm.invalid || disableLoginButton" type="submit"
                variant="progressive" class="login-btn" disabled="false">
              </f-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>